module.exports = __webpack_public_path__ + "img/02_active.25c8d3c4.png";